<!-- Modal Backdrop -->
<div class="blur-modal-backdrop" 
     [class.fade-in]="!isClosing" 
     [class.fade-out]="isClosing"
     (click)="onBackdropClick($event)">
</div>

<!-- Modal -->
<div class="mantis-modal" 
     role="dialog" 
     aria-modal="true" 
     [class.modal-in]="!isClosing" 
     [class.modal-out]="isClosing">
    <div class="modal-dialog chat-room-modal-dialog" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="modal-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">{{ modalTitle }}</h5>
            <button type="button" 
                    class="btn-close" 
                    (click)="onClose()"
                    aria-label="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close" />
            </button>
        </div>
        
        <!-- Modal Body -->
        <div class="modal-body">
            <!-- Step Indicator -->
            <div class="step-indicator">
                <span class="step-indicator-badge">{{ stepLabel }}</span>
            </div>

            <!-- Step 1: Group Setup -->
            @if (currentStep === 1) {
                <form #chatRoomForm="ngForm">
                    <!-- Group chat name -->
                    <div class="form-group mb-3">
                        <label class="form-label">
                            Group chat name <span class="text-danger">*</span>
                        </label>
                        <input type="text"
                            class="form-control"
                            name="name"
                            required
                            [(ngModel)]="formData.name"
                            placeholder="e.g. Morning Training Group"
                            [class.is-invalid]="chatRoomForm.submitted && !formData.name?.trim()">
                        <small class="form-text text-muted">
                            This name is visible to users in the app.
                        </small>
                        <div class="invalid-feedback d-block" *ngIf="chatRoomForm.submitted && !formData.name?.trim()">
                            Group chat name is required.
                        </div>
                    </div>

                    <!-- Description and Image Row -->
                    <div class="row mb-3">
                        <!-- Description -->
                        <div class="col-md-8">
                            <div class="form-group">
                                <label class="form-label">
                                    Description (optional)
                                </label>
                                <textarea class="form-control description-textarea"
                                        name="description"
                                        [(ngModel)]="formData.description"
                                        placeholder="Use this description as a private note about what this group chat is for."></textarea>
                                <small class="form-text text-muted">
                                    This description is visible only to you.
                                </small>
                            </div>
                        </div>

                        <!-- Image -->
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label">
                                    Image (optional)
                                </label>
                                <div class="image-upload-container">
                                    <div *ngIf="formData.imageUrl" class="image-preview">
                                        <img [src]="formData.imageUrl" alt="Chat room image" class="preview-image">
                                        <button type="button" 
                                                class="btn-remove-image" 
                                                (click)="onRemoveImage()"
                                                title="Remove image">
                                            <i class="ti ti-x"></i>
                                        </button>
                                    </div>
                                    <div *ngIf="!formData.imageUrl"
                                         class="image-upload-placeholder"
                                         (click)="onImagePlaceholderClick(fileInput)">
                                        <label for="chat-room-image-input" 
                                            class="image-upload-label"
                                            (click)="onLabelClick($event)">
                                            <img src="assets/common/ic_upload_m_size.svg" alt="" class="image-upload-icon">
                                            <span>Upload</span>
                                        </label>
                                        <input type="file"
                                            id="chat-room-image-input"
                                            accept="image/*"
                                            class="d-none"
                                            #fileInput
                                            (change)="onImageSelect($event)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Users can send messages checkbox -->
                    <!--
                    <div class="form-group mb-0 checkbox-with-description">
                        <div class="form-check checkbox-column">
                            <input class="form-check-input"
                                type="checkbox"
                                name="usersCanSendMessages"
                                id="users-can-send-messages"
                                [checked]="!formData.is_read_only"
                                (change)="onUsersCanSendMessagesChange($event)">
                        </div>
                        <div class="checkbox-text-column">
                            <label class="form-check-label" for="users-can-send-messages">
                                Users can send messages
                            </label>
                            <small class="form-text text-muted mt-0">
                                Choose whether all members can send messages or if posting is limited to coaches only.
                            </small>
                        </div>
                    </div>
                    -->
                </form>
            }

            <!-- Step 2: Add Members -->
            @if (currentStep === 2) {
                <div class="step-2-content">
                    <h6>Add members (optional)</h6>
                    <p>
                        You can add users by selecting tags or manually choosing users from the full list. You can also create the group chat now and add members later.
                    </p>

                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link"
                                    [class.active]="activeTab === 'tags'"
                                    type="button"
                                    (click)="activeTab = 'tags'">
                                <img [src]="activeTab === 'tags' ? 'assets/common/ic_tag_light.svg' : 'assets/common/ic_tag.svg'" 
                                    alt="Tags" 
                                    class="tab-icon">
                                Tags
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link"
                                    [class.active]="activeTab === 'status'"
                                    type="button"
                                    (click)="activeTab = 'status'">
                                <img [src]="activeTab === 'status' ? 'assets/common/ic_subscription_status_light.svg' : 'assets/common/ic_subscription_status.svg'" 
                                    alt="Status" 
                                    class="tab-icon">
                                Status
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link"
                                    [class.active]="activeTab === 'allUsers'"
                                    type="button"
                                    (click)="activeTab = 'allUsers'; onAllUsersTabActivated()">
                                <img [src]="activeTab === 'allUsers' ? 'assets/common/ic_users_light.svg' : 'assets/common/ic_users.svg'" 
                                    alt="All users" 
                                    class="tab-icon">
                                All users
                            </button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content">
                        <!-- Tags Tab -->
                        @if (activeTab === 'tags') {
                            <div class="tab-pane active">
                                @if (customTags.length > 0) {
                                    <div class="tags-container">
                                        <div class="tags-grid">
                                            @for (tag of customTags; track tag.id) {
                                                <button type="button"
                                                        class="btn tag-pill"
                                                        [class.tag-pill-selected]="isTagSelected(tag.id)"
                                                        (click)="toggleTagSelection(tag.id)">
                                                    <img [src]="isTagSelected(tag.id) ? 'assets/common/ic_tag_light.svg' : 'assets/common/ic_tag.svg'" 
                                                        alt="Tag" 
                                                        class="tag-icon">
                                                    {{ tag.name }} ({{ tag.items_count || 0 }})
                                                </button>
                                            }
                                        </div>
                                        @if (hasAnySelections) {
                                            <div class="users-count-message">
                                                @if (isCountingUsers) {
                                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Calculating...
                                                } @else {
                                                    {{ totalUsersCount }} users will be added with the selected tags.
                                                }
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="empty-state">
                                        <h6 class="empty-state-title">No tags created yet</h6>
                                        <p class="empty-state-text">
                                            Create tags first to add users to this group chat using tags.
                                        </p>
                                    </div>
                                }
                            </div>
                        }
                        
                        <!-- Status Tab -->
                        @if (activeTab === 'status') {
                            <div class="tab-pane active">
                                @if (subscriptionTags.length > 0) {
                                    <div class="tags-container">
                                        <div class="tags-grid">
                                            @for (tag of subscriptionTags; track tag.id) {
                                                <button type="button"
                                                        class="btn tag-pill"
                                                        [class.tag-pill-selected]="isTagSelected(tag.id)"
                                                        (click)="toggleTagSelection(tag.id)">
                                                    <img [src]="isTagSelected(tag.id) ? 'assets/common/ic_subscription_status_light.svg' : 'assets/common/ic_subscription_status.svg'" 
                                                        alt="Status" 
                                                        class="tag-icon">
                                                    {{ tag.name }} ({{ tag.items_count || 0 }})
                                                </button>
                                            }
                                        </div>
                                        @if (hasAnySelections) {
                                            <div class="users-count-message">
                                                @if (isCountingUsers) {
                                                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Calculating...
                                                } @else {
                                                    {{ totalUsersCount }} users will be added with the selected tags.
                                                }
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <div class="empty-state">
                                        <h6 class="empty-state-title">No subscription statuses available</h6>
                                        <p class="empty-state-text">
                                            No subscription status tags are available at this time.
                                        </p>
                                    </div>
                                }
                            </div>
                        }
                        
                        <!-- All Users Tab -->
                        @if (activeTab === 'allUsers') {
                            <div class="tab-pane active">
                                <div class="all-users-tab">
                                    <!-- Search Field -->
                                    <div class="form-search position-relative mb-3">
                                        <span class="search-icon">
                                            <img src="assets/common/ic_search.svg" alt="Search">
                                        </span>
                                        <input type="search"
                                            class="form-control"
                                            placeholder="Search users"
                                            [(ngModel)]="searchUsersQuery"
                                            (input)="onSearchUsersInput()">
                                        <button type="button"
                                                class="clear-search"
                                                *ngIf="searchUsersQuery"
                                                (click)="clearSearchUsers()"
                                                aria-label="Clear search">
                                            <img src="assets/common/ic_x.svg" alt="Clear search">
                                        </button>
                                    </div>

                                    <!-- Users List -->
                                    <div class="users-list-container">
                                        @if (searchUsersLoading) {
                                            <div class="text-center py-4">
                                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Loading users...
                                            </div>
                                        } @else if (searchUsersList.length > 0) {
                                            <div class="users-list-with-checkboxes p-2">
                                                @for (user of searchUsersList; track user.id) {
                                                    <div class="user-item"
                                                        [class.user-item-selected]="isUserSelected(user.id)">
                                                        <div class="form-check">
                                                            <input class="form-check-input"
                                                                type="checkbox"
                                                                [id]="'user-' + user.id"
                                                                [checked]="isUserSelected(user.id)"
                                                                (change)="toggleUserSelection(user.id)">
                                                            <label class="form-check-label d-flex align-items-center w-100"
                                                                [for]="'user-' + user.id">
                                                                <div class="user-avatar">
                                                                    @if (user.avatar) {
                                                                        <img [src]="user.avatar" [alt]="user.name" class="avatar-image">
                                                                    } @else {
                                                                        <div class="avatar-circle">
                                                                            <span class="avatar-initials">{{ getInitials(user.name) }}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div class="user-info flex-grow-1">
                                                                    <div class="user-name">{{ user.name }}</div>
                                                                    <div class="user-email">{{ user.email }}</div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <!-- Pagination -->
                                            @if (searchUsersTotalPages > 1) {
                                                <div class="pagination-container">
                                                    <nav aria-label="Users pagination">
                                                        <ul class="pagination pagination-sm justify-content-center mb-0">
                                                            <li class="page-item" [class.disabled]="searchUsersPage === 1">
                                                                <a class="page-link" 
                                                                (click)="onSearchUsersPageChange(searchUsersPage - 1)"
                                                                [attr.aria-disabled]="searchUsersPage === 1">
                                                                    Previous
                                                                </a>
                                                            </li>
                                                            @for (page of getPaginationPages(); track page) {
                                                                <li class="page-item" [class.active]="page === searchUsersPage">
                                                                    @if (page === '...') {
                                                                        <span class="page-link">...</span>
                                                                    } @else {
                                                                        <a class="page-link" 
                                                                        (click)="onPaginationPageClick(page)">
                                                                            {{ page }}
                                                                        </a>
                                                                    }
                                                                </li>
                                                            }
                                                            <li class="page-item" [class.disabled]="searchUsersPage === searchUsersTotalPages">
                                                                <a class="page-link" 
                                                                (click)="onSearchUsersPageChange(searchUsersPage + 1)"
                                                                [attr.aria-disabled]="searchUsersPage === searchUsersTotalPages">
                                                                    Next
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            }
                                        } @else if (!searchUsersLoading) {
                                            <div class="empty-state">
                                                <h6 class="empty-state-title">No users found</h6>
                                                <p class="empty-state-text">
                                                    @if (searchUsersQuery) {
                                                        We couldn't find any users matching your search. Try adjusting the name or using a different search term.
                                                    } @else {
                                                        There are no users in the app yet. Once users join, you'll be able to add them to this group chat.
                                                    }
                                                </p>
                                            </div>
                                        }
                                    </div>

                                    <!-- Selected Users Count (outside scrollable container) -->
                                    @if (selectedUsersCount > 0) {
                                        <div class="users-count-message">
                                            {{ selectedUsersCount }} user{{ selectedUsersCount === 1 ? '' : 's' }} selected.
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        
        <!-- Modal Footer -->
        <div class="modal-footer d-flex justify-content-between align-items-center gap-2">
            @if (currentStep === 1) {
                <div></div>
                <div class="d-flex gap-2">
                    <button type="button" 
                            class="btn btn-outline-secondary" 
                            (click)="onClose()">
                        Cancel
                    </button>
                    <button type="button" 
                            class="btn btn-primary" 
                            [disabled]="!isFormValid()"
                            (click)="onNext()">
                        Next
                    </button>
                </div>
            }
            
            @if (currentStep === 2) {
                <button type="button" 
                        class="btn btn-outline-secondary d-flex align-items-center gap-2"
                        (click)="onBack()">
                    <i class="ti ti-arrow-left"></i>
                    Back to Step 1
                </button>
                <div class="d-flex gap-2">
                    <button type="button" 
                            class="btn btn-outline-secondary" 
                            (click)="onClose()">
                        Cancel
                    </button>
                    <button type="button" 
                            class="btn btn-primary" 
                            [disabled]="isSaving"
                            (click)="onCreate()">
                        @if (isSaving) {
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        }
                        {{ createButtonText }}
                    </button>
                </div>
            }
        </div>
    </div>
</div>

